<template>
  <path pid="0" d="M23 12h-4a1 1 0 00-.95.68L16 18.84 11 3.68a1 1 0 00-1.9 0L6.28 12H3a1 1 0 000 2h4a1 1 0 001-.68l2-6.16 5.05 15.16a1 1 0 001.9 0L19.72 14H23a1 1 0 000-2z"/>
</template>
